const BASE_URL = 'https://apihmg.rhgestao.com';
const CEP_BASE_URL = 'https://viacep.com.br/ws/{cep}/json/';
const IBGE_BASE_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades';

export const environment = {
  apiUrl: `${BASE_URL}/api/v1`,
  imagesApiUrl: `${BASE_URL}/images/companies`,
  cepService: CEP_BASE_URL,
  ibgeService: IBGE_BASE_URL,
  production: false,
  langflow: {
    scriptUrl: 'https://cdn.jsdelivr.net/gh/logspace-ai/langflow-embedded-chat@v1.0.7/dist/build/static/js/bundle.min.js',
    hostUrl: 'https://langflow.rhgestao.com',
    apiKey: 'sk-vsW_CejsI85hQAlIYvhJTAWy6Rdlk2fq4uwB9pjSWME',
  },
};
